import React from 'react';
import { KoobTooltip, KoobBadge } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@koob/dates';

function RoomTags({ room }) {
  const { t } = useTranslation('booking', { keyPrefix: 'room' });

  const bedChoice = room?.bedChoice ?? room?.bedChoices?.[0];
  const tags = bedChoice?.tags?.length > 0 ? bedChoice?.tags : room?.tags;
  const filteredTags = tags?.filter(t => !!t.label);

  const badgeColor = code => {
    switch (code) {
      case 'refundable':
        return 'green';
      case 'non_refundable':
        return 'red';
      default:
        return 'gray';
    }
  };

  return filteredTags?.length > 0 ? (
    <>
      {filteredTags.map((tag, index) => (
        <KoobTooltip
          key={index}
          tip={
            tag?.startAt && tag?.endAt
              ? `${formatDate(tag?.startAt, 'DD/MM/YYYY')} - ${formatDate(tag?.endAt, 'DD/MM/YYYY')}`
              : ''
          }
          disabled={!tag?.startAt || !tag?.endAt}
          color="purple"
          hasArrow={false}
          position="left"
        >
          <KoobBadge color={badgeColor(tag.code)}>
            {tag.label?.indexOf('_') !== -1 || tag.label?.indexOf('.') !== -1
              ? t(tag.label)
              : tag.label}
          </KoobBadge>
        </KoobTooltip>
      ))}
    </>
  ) : null;
}

export default RoomTags;
